import { render, staticRenderFns } from "./FeatureComments.vue?vue&type=template&id=6bb0d928&scoped=true"
import script from "./FeatureComments.vue?vue&type=script&lang=js"
export * from "./FeatureComments.vue?vue&type=script&lang=js"
import style0 from "./FeatureComments.vue?vue&type=style&index=0&id=6bb0d928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0d928",
  null
  
)

export default component.exports